// extracted by mini-css-extract-plugin
export default {"grid":"CampaignGrid_grid__gfuui"};